import request from "../../../../utils/api";

const url = "api/v1/companies"

export const getProducts = (id, params) => request(`${url}/${id}/products`, { params });
export const getAllProducts = id => request(`${url}/${id}/products`);
export const createProduct = (company_id, body) => request(`${url}/${company_id}/products`, { method: "post", body });
export const updateProduct = (company_id, product_id, body) => request(`${url}/${company_id}/products/${product_id}`, { method: "put", body });
export const deleteProduct = (company_id, product_id) => request(`${url}/${company_id}/products/${product_id}`, { method: "delete" });


// WEBPACK FOOTER //
// ./src/modules/company/pages/product/service.js